export default function swDev() {
    let swUrl = `${process.env.PUBLIC_URL}/sw.js`

    navigator.serviceWorker.register(swUrl, { scope: "/" }).then((res) => {
        console.warn('Service Worker registered successfully:', res);
    }).catch((err) => {
        console.error('Error registering Service Worker:', err);
    })
}